import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const DialogConfirmApproveRejectTicket = props => {
    useTranslationSubscription();
    const { isOpen, setIsOpen } = props;
    let msgCode = '';

    switch (props.selectedApproveFlag) {
        case Constant.APPROVE_FLAG.APPROVE:
            msgCode = 'USER04MSG026';
            break;
        case Constant.APPROVE_FLAG.REJECTED:
            msgCode = 'USER04MSG027';
            break;
        default:
            break;
    }

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setSelectedApproveFlag('');
        setIsOpen(false);
    };

    const onSubmitEditTicket = () => {
        props.submitApproveReject(props.selectedApproveFlag, props);
        props.setSelectedApproveFlag('');
        setIsOpen(false);
    };

    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content" id="alert-dialog-delete-addition-user-content">
                    {trI18n(msgCode)}
                </div>
            </DialogContent>
            <DialogActions className="confirm-delete-user-dialog-action">
                <Button
                    className="btn-handle-delete-user btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={onSubmitEditTicket}
                >
                    {trI18n('COMBTN002')}
                </Button>
                <Button
                    className="btn-handle-delete-user btn-handle-delete-user-disagree"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
